import type { ReactNode } from 'react';

export const symbol_remember_me: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M260-40q-24.75 0-42.37-17.63Q200-75.25 200-100v-760q0-24.75 17.63-42.38Q235.25-920 260-920h440q24.75 0 42.38 17.62Q760-884.75 760-860v760q0 24.75-17.62 42.37Q724.75-40 700-40H260Zm0-90v30h440v-30H260Zm0-700h440v-30H260v30Zm220 530q-59.54 0-115.77 18T260-235v45h440v-45q-48-29-104.23-47-56.23-18-115.77-18Zm0-60q60 0 115.5 15.5T700-302v-468H260v468q50-27 105-42.5T480-360Zm83-96.76q34-33.77 34-82Q597-587 563.24-621q-33.77-34-82-34Q433-655 399-621.24q-34 33.77-34 82Q365-491 398.76-457q33.77 34 82 34Q529-423 563-456.76ZM441.5-499.5Q425-516 425-539t16.5-39.5Q458-595 481-595t39.5 16.5Q537-562 537-539t-16.5 39.5Q504-483 481-483t-39.5-16.5ZM480-190h220-440 220Zm1-349Zm-1-291Zm0 700Z"
		/>
	</svg>
);
